import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRedirect, DomainRoute } from '../utils/domain/routingComponents'
import { partnerPickDevicesAccessControl } from '../access-control/partnerPickDevicesAccess.configuration'
import { equipmentDataAccessControl } from '../access-control/equipmentDataAccess.configuration'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { PartnerPickDevicesScopePicker } from '../components/scope-picker/PartnerPickDevicesScopePicker'

const PartnerPickDevicesListPage = lazy(() => import('../pages/list/PartnerPickDevicesListPage'))
const PartnerPickDevicesEditPage = lazy(() => import('../pages/edit/PartnerPickDevicesEditPage'))
// @hygen:inject page-import

type ConfigArray = Extract<DomainAccessControlConfig, unknown[]>
const combinedAccessControl: DomainAccessControlConfig = [
  ...(partnerPickDevicesAccessControl as ConfigArray),
  ...(equipmentDataAccessControl as ConfigArray),
]

export const partnerPickDevicesRouter = (
  <DomainRoute route="partner-pick-devices" accessControl={combinedAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="partner-pick-devices-list"
        component={PartnerPickDevicesListPage}
        scopePickerComponent={PartnerPickDevicesScopePicker}
      />
      <DomainRoute exact route="partner-pick-devices-edit" component={PartnerPickDevicesEditPage} />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}

      <DomainRedirect fromRoute="partner-pick-devices" toRoute="partner-pick-devices-list" />
    </DashSwitch>
  </DomainRoute>
)
